import React from 'react';
import { useApp } from '../../context/AppContext';
import { Avatar } from '../ui/Avatar';
import { isWithinInterval, parseISO } from 'date-fns';

export function WhosOut() {
  const { requests, getEmployee } = useApp();
  const today = new Date();

  const outToday = requests.filter(r => {
    if (r.status !== 'approved') return false;
    try {
      return isWithinInterval(today, { start: parseISO(r.from), end: parseISO(r.to) });
    } catch { return false; }
  });

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-semibold th-text">Who's Out Today</h3>
        <span className="text-xs th-muted">{outToday.length} away</span>
      </div>
      {outToday.length === 0 ? (
        <p className="text-sm th-muted text-center py-4">Everyone's in today 🎉</p>
      ) : (
        <div className="flex flex-col gap-3">
          {outToday.map(r => {
            const emp = getEmployee(r.empId);
            if (!emp) return null;
            return (
              <div key={r.id} className="flex items-center gap-3">
                <Avatar employee={emp} size="sm" />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p className="text-sm font-medium th-text truncate">{emp.name}</p>
                  <p className="text-xs th-muted truncate">{r.type} · until {r.to}</p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}